import {Component} from '@angular/core';
import {Platform} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {PrintService} from '@app/core/services/print.service';
import {SegmentService} from '@app/core/services/segment.service';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
})
export class AppComponent {
	constructor(
		private platform: Platform,
		private splashScreen: SplashScreen,
		private statusBar: StatusBar,
		private print: PrintService,
		private segmentService: SegmentService,
	) {
		this.initializeApp();
	}

	public initializeApp(): void {

		this.segmentService.start();

		this.platform.ready().then(() => {
			this.statusBar.styleDefault();
			this.splashScreen.hide();
			const godefer2 = document.getElementsByTagName('link')[0];

			let linkElement = document.createElement('link');
			linkElement.rel = 'stylesheet';
			linkElement.type = 'text/css';
			linkElement.crossOrigin = 'anonymous';
			linkElement.href = 'https://fonts.googleapis.com/css?family=Material+Icons';
			godefer2.parentNode.insertBefore(linkElement, godefer2);

			linkElement = document.createElement('link');
			linkElement.rel = 'stylesheet';
			linkElement.type = 'text/css';
			linkElement.crossOrigin = 'anonymous';
			linkElement.href = 'https://use.fontawesome.com/releases/v5.5.0/css/all.css';
			godefer2.parentNode.insertBefore(linkElement, godefer2);

			linkElement = document.createElement('link');
			linkElement.rel = 'stylesheet';
			linkElement.type = 'text/css';
			linkElement.crossOrigin = 'anonymous';
			linkElement.href = 'https://fonts.googleapis.com/css?family=Nunito+Sans:400,700|Nunito:600|Raleway:700';
			godefer2.parentNode.insertBefore(linkElement, godefer2);
		});
		window.addEventListener('beforeprint', (event) => {
			event.preventDefault();
			event.stopPropagation();

			return false;
		});
		document.addEventListener('keydown', (e: KeyboardEvent) => {
			if (e.code === 'KeyP' && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
				e.preventDefault();
				this.print.startPrint();
			}
		}, false);
	}

}
